import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-642dee47"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info-label" }, "회원명", -1))
const _hoisted_2 = { class: "info-value" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info-label" }, "서비스코드", -1))
const _hoisted_4 = { class: "info-value" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info-label" }, "상품명/서비스명", -1))
const _hoisted_6 = { class: "info-value" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info-label" }, "휴대폰번호", -1))
const _hoisted_8 = { class: "info-value" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info-label" }, "이메일", -1))
const _hoisted_10 = { class: "info-value" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info-label" }, "사용자정의 필드", -1))
const _hoisted_12 = { class: "info-value" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info-label" }, "은행코드", -1))
const _hoisted_14 = { class: "info-value" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info-label" }, "출금계좌번호", -1))
const _hoisted_16 = { class: "info-value" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info-label" }, "출금계좌 예금주명", -1))
const _hoisted_18 = { class: "info-value" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info-label" }, "생년월일/사업자번호", -1))
const _hoisted_20 = { class: "info-value" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info-label" }, "카드번호", -1))
const _hoisted_22 = { class: "info-value" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info-label" }, "카드 유효기간", -1))
const _hoisted_24 = { class: "info-value" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info-label" }, "발행타입", -1))
const _hoisted_26 = { class: "info-value" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info-label" }, "인증번호", -1))
const _hoisted_28 = { class: "info-value" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info-label" }, "회원상태", -1))
const _hoisted_30 = { class: "info-value" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info-label" }, "은행등록 결과", -1))
const _hoisted_32 = { class: "info-value" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info-label" }, "회원등록일자", -1))
const _hoisted_34 = { class: "info-value" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info-label" }, "은행등록일자", -1))
const _hoisted_36 = { class: "info-value" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info-label" }, "회원해지일자", -1))
const _hoisted_38 = { class: "info-value" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-subtitle-2 mb-2" }, "파일 업로드 규칙", -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", { class: "text-body-2" }, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "서면:"),
    /*#__PURE__*/_createTextVNode(" jpg, jpeg, gif, tif, pdf (최대 300KB)")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "녹취:"),
    /*#__PURE__*/_createTextVNode(" mp3, wav, wma (최대 300KB)")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "전자서명:"),
    /*#__PURE__*/_createTextVNode(" der (최대 10KB)")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "파일명 규칙:"),
    /*#__PURE__*/_createTextVNode(" 이용기관코드.회원아이디.증빙자료구분.확장자")
  ])
], -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_42 = { class: "text-center mb-4" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-subtitle-1 font-weight-bold mb-2" }, "회원 정보", -1))
const _hoisted_44 = { class: "d-flex flex-column gap-2" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "회원상태:", -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "은행등록 결과:", -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "회원등록일자:", -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "은행등록일자:", -1))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "회원해지일자:", -1))

import { ref, computed, reactive, onMounted } from 'vue'
import axios from 'axios'

interface CmsMemberInfo {
  accountName: string;
  accountNo: string;
  bankCd: string;
  bankResultCd: string;
  bankResultMsg: string;
  bankSendDt: string;
  cardNo: string;
  cusOffNo: string;
  cusType: string;
  email: string;
  hpNo: string;
  idNo: string;
  memberName: string;
  regDt: string;
  serviceCd: string;
  serviceName: string;
  status: string;
  stopDt: string;
  userDefine: string;
  valYn: string;
}

interface CmsResponse {
  memberInfo: CmsMemberInfo;
  resultCd: string;
  resultMsg: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CmsTest',
  setup(__props) {

const waitStatus = ref(false)
const memberId = ref('testuser01')
const bankCodes = ref([])  // 은행 코드 목록을 저장할 상태 추가
const cmsMembers = ref<CmsResponse[]>([])  // CMS 회원 목록을 저장할 상태 추가
const form = ref({
  memberName: '홍길동',        // 회원 성명 (20byte, 필수) - 마스킹 처리됨
  serviceCd: 'BANK',          // 서비스코드 (4byte, 필수) - 은행:BANK, 카드:CARD
  bankCd: '002',              // 은행코드 (3byte) - serviceCd가 BANK인 경우 필수
  accountNo: '12345678901234', // 출금계좌번호 (16byte) - serviceCd가 BANK인 경우 필수, 마스킹 처리됨
  accountName: '홍길동',       // 출금계좌 예금주 성명 (20byte) - serviceCd가 BANK인 경우 필수, 마스킹 처리됨
  idNo: '900101',             // 출금계좌 예금주 생년월일 앞6자리 또는 사업자번호 10자리 (10byte) - serviceCd가 BANK인 경우 필수, 마스킹 처리됨
  hpNo: '01012345678',        // 회원 휴대폰번호 (16byte, 필수)
  email: 'hong@example.com',  // 이메일 주소 (30byte)
  serviceName: '자동이체서비스', // 상품명/서비스명 (30byte)
  cardNo: '',                 // 카드번호 (16byte) - serviceCd가 CARD인 경우 필수, 마스킹 처리됨
  valYn: '',                  // 카드 유효기간 YYMM (4byte) - serviceCd가 CARD인 경우 필수
  cusType: '1',               // 현금영수증 발행타입 (1byte) - 소득공제:1, 지출증빙:2
  cusOffNo: '01012345678',    // 현금영수증 발행 시 인증번호 (20byte)
  userDefine: '테스트회원'     // 사용자정의 필드 (20byte)
})

const result = ref<any>(null)

// 스낵바 상태
const snackbar = reactive({
  show: false,
  text: '',
  color: 'info'
})

const isSuccess = computed(() => {
  return result.value && result.value.success === true
})

// 스낵바 표시 함수
const showSnackbar = (text: string, color: any) => {
  snackbar.text = text
  snackbar.color = color
  snackbar.show = true
}

const sendRequest = async () => {
  try {
    waitStatus.value = true
    result.value = null
    const res = await axios.post('/api/cms/register', {
      memberId: memberId.value,
      data: form.value
    })
    
    result.value = res.data
    
    if (result.value.success) {
      showSnackbar('CMS API 요청이 성공했습니다!', 'success');
    } else {
      const errorMsg = result.value.error?.message || 'API 요청 실패';
      const statusCode = result.value.statusCode || res.status;
      
      console.error('=== API 오류 상세 ===');
      console.error('Status Code:', statusCode);
      console.error('Error:', result.value.error);
      console.error('Message:', result.value.message);
      console.error('==================');
      
      showSnackbar(`API 오류 (${statusCode}): ${errorMsg}`, 'error');
    }
  } catch (err: any) {
    result.value = err.response?.data || { success: false, error: err.message }
    
    console.error('=== 네트워크 오류 ===');
    console.error('Error:', err);
    console.error('==================');
    
    showSnackbar(`네트워크 오류: ${err.message}`, 'error');
  } finally {
    waitStatus.value = false
  }
}

const getBankCodes = async () => {
  try {
    const response = await axios.get('/api/cms/getBankCodes');
    if (response.data.success) {
      bankCodes.value = response.data.data;
    } else {
      showSnackbar('은행 코드 목록을 가져오는데 실패했습니다.', 'error');
    }
  } catch (error) {
    console.error('은행 코드 조회 오류:', error);
    showSnackbar('은행 코드 목록을 가져오는데 실패했습니다.', 'error');
  }
};

const getCmsMember = async () => {
  try {
    waitStatus.value = true;
    const response = await axios.get('/api/cms/getCmsMember', {
      params: { memberId: memberId.value }
    });
    
    if (response.data.success) {
      // API 응답 데이터 구조에 맞게 수정
      cmsMembers.value = Array.isArray(response.data.data) ? response.data.data : [response.data.data];
      showSnackbar('회원 조회가 완료되었습니다.', 'success');
    } else {
      showSnackbar('회원 조회에 실패했습니다.', 'error');
    }
  } catch (error: any) {
    console.error('회원 조회 오류:', error);
    showSnackbar(`회원 조회 오류: ${error.message}`, 'error');
  } finally {
    waitStatus.value = false;
  }
};

const deleteDialog = ref(false)

const confirmDelete = () => {
  deleteDialog.value = true
}

const deleteMember = async () => {
  try {
    waitStatus.value = true
    const response = await axios.delete(`/api/cms/members/${memberId.value}`)
    
    if (response.data.success) {
      
      console.log(response.data.data.resultCd,'response.data.resultCd')
      if(response.data.data.resultCd === '0000'){
        showSnackbar('회원이 성공적으로 해지되었습니다.', 'success')
        deleteDialog.value = false
        // 회원 목록 새로고침
        await getCmsMember()
      }else if(response.data.data.resultCd === '3005'){
        showSnackbar('회원이 이미 해지되었습니다.', 'error')
      }else{
        showSnackbar('회원 해지에 실패했습니다.', 'error')
      }
    } else {
      showSnackbar('회원 해지에 실패했습니다.', 'error')
    }
  } catch (error: any) {
    console.error('회원 해지 오류:', error)
    showSnackbar(`회원 해지 오류: ${error.message}`, 'error')
  } finally {
    waitStatus.value = false
  }
}

onMounted(() => {
  getBankCodes();
  getCmsMember();
});

// 회원상태 텍스트 변환 함수 수정
const getStatusText = (status: string) => {
  const statusMap: { [key: string]: string } = {
    '0': '등록대기',
    '1': '정상 등록',
    '2': '등록실패',
    '3': '해지'
  };
  return statusMap[status] || status;
};

// 회원상태에 따른 색상 반환 함수 추가
const getStatusColor = (status: string) => {
  const colorMap: { [key: string]: string } = {
    '0': 'warning',
    '1': 'success',
    '2': 'error',
    '3': 'grey'
  };
  return colorMap[status] || 'grey';
};

// 파일 업로드 관련 로직
const fileForm = ref({
  agreeType: '',
  uploadMethod: 'multipart',
  file: null
})

const fileUploadStatus = ref(false)

const getAcceptedFileTypes = () => {
  if (fileForm.value.agreeType === '1') {
    // 서면: jpg, jpeg, gif, tif, pdf
    return '.jpg,.jpeg,.gif,.tif,.pdf'
  } else if (fileForm.value.agreeType === '2') {
    // 전자서명: der
    return '.der'
  } else if (fileForm.value.agreeType === '4') {
    // 녹취: mp3, wav, wma
    return '.mp3,.wav,.wma'
  }
  return ''
}

const onFileChange = (event: Event) => {
  const files = fileForm.value.file as File[] | null
  const file = files?.[0]
  if (!file) return

  // 파일 크기 체크
  const maxSize = fileForm.value.agreeType === '2' ? 10 * 1024 : 300 * 1024 // 전자서명: 10KB, 나머지: 300KB
  
  if (file.size > maxSize) {
    const maxSizeText = fileForm.value.agreeType === '2' ? '10KB' : '300KB'
    showSnackbar(`파일 크기가 ${maxSizeText}를 초과합니다.`, 'error')
    fileForm.value.file = null
    return
  }

  // 파일 확장자 체크
  const fileExt = file.name.split('.').pop()?.toLowerCase()
  const allowedExts = getAllowedExtensions()
  
  if (!allowedExts.includes(fileExt || '')) {
    showSnackbar(`허용되지 않는 파일 형식입니다. (${allowedExts.join(', ')})`, 'error')
    fileForm.value.file = null
    return
  }
}

const getAllowedExtensions = () => {
  if (fileForm.value.agreeType === '1') {
    return ['jpg', 'jpeg', 'gif', 'tif', 'pdf']
  } else if (fileForm.value.agreeType === '2') {
    return ['der']
  } else if (fileForm.value.agreeType === '4') {
    return ['mp3', 'wav', 'wma']
  }
  return []
}

const uploadAgreeFile = async () => {
  try {
    fileUploadStatus.value = true
    
    if (!fileForm.value.file || !fileForm.value.agreeType || !fileForm.value.uploadMethod) {
      showSnackbar('파일과 증빙파일 구분을 선택해주세요.', 'error')
      return
    }

    const files = fileForm.value.file as File[] | null
    const file = files?.[0]
    if (!file) {
      showSnackbar('파일을 선택해주세요.', 'error')
      return
    }

    const fileExt = file.name.split('.').pop()?.toLowerCase() || ''

    if (fileForm.value.uploadMethod === 'multipart') {
      // Multipart 방식
      const formData = new FormData()
      
      formData.append('agreetype', fileForm.value.agreeType)
      formData.append('fileext', fileExt)
      formData.append('file', file)
      
      const response = await axios.post(`/api/cms/uploadAgreeFile/${memberId.value}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      
      if (response.data.success) {
        showSnackbar('증빙파일이 성공적으로 업로드되었습니다. (Multipart)', 'success')
      } else {
        showSnackbar('증빙파일 업로드에 실패했습니다.', 'error')
      }
    } else {
      // Base64 방식
      const reader = new FileReader()
      reader.onload = async (e) => {
        try {
          const base64Data = (e.target?.result as string)?.split(',')[1] // data:mime;base64, 부분 제거
          
          const response = await axios.post(`/api/cms/uploadAgreeFileBase64/${memberId.value}`, {
            agreetype: fileForm.value.agreeType,
            fileext: fileExt,
            fileData: base64Data
          })
          
          if (response.data.success) {
            showSnackbar('증빙파일이 성공적으로 업로드되었습니다. (Base64)', 'success')
          } else {
            showSnackbar('증빙파일 업로드에 실패했습니다.', 'error')
          }
        } catch (error: any) {
          console.error('Base64 업로드 오류:', error)
          showSnackbar(`Base64 업로드 오류: ${error.message}`, 'error')
        }
      }
      reader.readAsDataURL(file)
    }
    
    // 폼 초기화
    fileForm.value = {
      agreeType: '',
      uploadMethod: 'multipart',
      file: null
    }
    
  } catch (error: any) {
    console.error('증빙파일 업로드 오류:', error)
    showSnackbar(`증빙파일 업로드 오류: ${error.message}`, 'error')
  } finally {
    fileUploadStatus.value = false
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_file_input = _resolveComponent("v-file-input")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_expansion_panel_title = _resolveComponent("v-expansion-panel-title")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!
  const _component_v_code = _resolveComponent("v-code")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, { justify: "center" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            md: "10",
            lg: "8"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, { elevation: "3" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_title, { class: "text-center bg-primary" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, { class: "me-2" }, {
                        default: _withCtx(() => [
                          _createTextVNode("mdi-bank-transfer")
                        ]),
                        _: 1
                      }),
                      _createTextVNode(" CMS 자동이체 테스트 ")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_card_text, { class: "pa-6" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            cols: "12",
                            sm: "8"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_text_field, {
                                modelValue: memberId.value,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((memberId).value = $event)),
                                label: "회원 ID",
                                "prepend-icon": "mdi-account",
                                variant: "outlined",
                                hint: "테스트할 회원의 고유 ID를 입력하세요"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            cols: "12",
                            sm: "4",
                            class: "d-flex align-center"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_btn, {
                                onClick: getCmsMember,
                                loading: waitStatus.value,
                                color: "primary",
                                block: "",
                                "prepend-icon": "mdi-account-search"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" 회원 조회 ")
                                ]),
                                _: 1
                              }, 8, ["loading"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      (cmsMembers.value.length > 0)
                        ? (_openBlock(), _createBlock(_component_v_card, {
                            key: 0,
                            variant: "outlined",
                            class: "mt-4"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_card_title, { class: "d-flex align-center" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_icon, { class: "me-2" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("mdi-account-group")
                                    ]),
                                    _: 1
                                  }),
                                  _createTextVNode(" 회원 정보 "),
                                  _createVNode(_component_v_spacer),
                                  _createVNode(_component_v_btn, {
                                    color: "error",
                                    variant: "tonal",
                                    "prepend-icon": "mdi-account-remove",
                                    onClick: confirmDelete,
                                    loading: waitStatus.value
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" 회원 해지 ")
                                    ]),
                                    _: 1
                                  }, 8, ["loading"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_card_text, null, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cmsMembers.value, (member, index) => {
                                    return (_openBlock(), _createBlock(_component_v_row, { key: index }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, { cols: "12" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_card, {
                                              variant: "outlined",
                                              class: "pa-4"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_card_title, { class: "section-title" }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_icon, { class: "me-2" }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode("mdi-account")
                                                      ]),
                                                      _: 1
                                                    }),
                                                    _createTextVNode(" 기본 정보 ")
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_v_card_text, null, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_row, null, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_col, {
                                                          cols: "12",
                                                          sm: "6",
                                                          md: "4"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _hoisted_1,
                                                            _createElementVNode("div", _hoisted_2, _toDisplayString(member?.memberInfo?.memberName || '-'), 1)
                                                          ]),
                                                          _: 2
                                                        }, 1024),
                                                        _createVNode(_component_v_col, {
                                                          cols: "12",
                                                          sm: "6",
                                                          md: "4"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _hoisted_3,
                                                            _createElementVNode("div", _hoisted_4, _toDisplayString(member?.memberInfo?.serviceCd || '-'), 1)
                                                          ]),
                                                          _: 2
                                                        }, 1024),
                                                        _createVNode(_component_v_col, {
                                                          cols: "12",
                                                          sm: "6",
                                                          md: "4"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _hoisted_5,
                                                            _createElementVNode("div", _hoisted_6, _toDisplayString(member?.memberInfo?.serviceName || '-'), 1)
                                                          ]),
                                                          _: 2
                                                        }, 1024),
                                                        _createVNode(_component_v_col, {
                                                          cols: "12",
                                                          sm: "6",
                                                          md: "4"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _hoisted_7,
                                                            _createElementVNode("div", _hoisted_8, _toDisplayString(member?.memberInfo?.hpNo || '-'), 1)
                                                          ]),
                                                          _: 2
                                                        }, 1024),
                                                        _createVNode(_component_v_col, {
                                                          cols: "12",
                                                          sm: "6",
                                                          md: "4"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _hoisted_9,
                                                            _createElementVNode("div", _hoisted_10, _toDisplayString(member?.memberInfo?.email || '-'), 1)
                                                          ]),
                                                          _: 2
                                                        }, 1024),
                                                        _createVNode(_component_v_col, {
                                                          cols: "12",
                                                          sm: "6",
                                                          md: "4"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _hoisted_11,
                                                            _createElementVNode("div", _hoisted_12, _toDisplayString(member?.memberInfo?.userDefine || '-'), 1)
                                                          ]),
                                                          _: 2
                                                        }, 1024)
                                                      ]),
                                                      _: 2
                                                    }, 1024)
                                                  ]),
                                                  _: 2
                                                }, 1024),
                                                _createVNode(_component_v_card_title, { class: "section-title" }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_icon, { class: "me-2" }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(member?.memberInfo?.serviceCd === 'BANK' ? 'mdi-bank' : 'mdi-credit-card'), 1)
                                                      ]),
                                                      _: 2
                                                    }, 1024),
                                                    _createTextVNode(" " + _toDisplayString(member?.memberInfo?.serviceCd === 'BANK' ? '계좌' : '카드') + " 정보 ", 1)
                                                  ]),
                                                  _: 2
                                                }, 1024),
                                                _createVNode(_component_v_card_text, null, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_row, null, {
                                                      default: _withCtx(() => [
                                                        (member?.memberInfo?.serviceCd === 'BANK')
                                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                              _createVNode(_component_v_col, {
                                                                cols: "12",
                                                                sm: "6",
                                                                md: "4"
                                                              }, {
                                                                default: _withCtx(() => [
                                                                  _hoisted_13,
                                                                  _createElementVNode("div", _hoisted_14, _toDisplayString(member?.memberInfo?.bankCd || '-'), 1)
                                                                ]),
                                                                _: 2
                                                              }, 1024),
                                                              _createVNode(_component_v_col, {
                                                                cols: "12",
                                                                sm: "6",
                                                                md: "4"
                                                              }, {
                                                                default: _withCtx(() => [
                                                                  _hoisted_15,
                                                                  _createElementVNode("div", _hoisted_16, _toDisplayString(member?.memberInfo?.accountNo || '-'), 1)
                                                                ]),
                                                                _: 2
                                                              }, 1024),
                                                              _createVNode(_component_v_col, {
                                                                cols: "12",
                                                                sm: "6",
                                                                md: "4"
                                                              }, {
                                                                default: _withCtx(() => [
                                                                  _hoisted_17,
                                                                  _createElementVNode("div", _hoisted_18, _toDisplayString(member?.memberInfo?.accountName || '-'), 1)
                                                                ]),
                                                                _: 2
                                                              }, 1024),
                                                              _createVNode(_component_v_col, {
                                                                cols: "12",
                                                                sm: "6",
                                                                md: "4"
                                                              }, {
                                                                default: _withCtx(() => [
                                                                  _hoisted_19,
                                                                  _createElementVNode("div", _hoisted_20, _toDisplayString(member?.memberInfo?.idNo || '-'), 1)
                                                                ]),
                                                                _: 2
                                                              }, 1024)
                                                            ], 64))
                                                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                              _createVNode(_component_v_col, {
                                                                cols: "12",
                                                                sm: "6",
                                                                md: "4"
                                                              }, {
                                                                default: _withCtx(() => [
                                                                  _hoisted_21,
                                                                  _createElementVNode("div", _hoisted_22, _toDisplayString(member?.memberInfo?.cardNo || '-'), 1)
                                                                ]),
                                                                _: 2
                                                              }, 1024),
                                                              _createVNode(_component_v_col, {
                                                                cols: "12",
                                                                sm: "6",
                                                                md: "4"
                                                              }, {
                                                                default: _withCtx(() => [
                                                                  _hoisted_23,
                                                                  _createElementVNode("div", _hoisted_24, _toDisplayString(member?.memberInfo?.valYn || '-'), 1)
                                                                ]),
                                                                _: 2
                                                              }, 1024)
                                                            ], 64))
                                                      ]),
                                                      _: 2
                                                    }, 1024)
                                                  ]),
                                                  _: 2
                                                }, 1024),
                                                _createVNode(_component_v_card_title, { class: "section-title" }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_icon, { class: "me-2" }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode("mdi-receipt")
                                                      ]),
                                                      _: 1
                                                    }),
                                                    _createTextVNode(" 현금영수증 정보 ")
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_v_card_text, null, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_row, null, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_col, {
                                                          cols: "12",
                                                          sm: "6",
                                                          md: "4"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _hoisted_25,
                                                            _createElementVNode("div", _hoisted_26, _toDisplayString(member?.memberInfo?.cusType === '1' ? '소득공제' : '지출증빙'), 1)
                                                          ]),
                                                          _: 2
                                                        }, 1024),
                                                        _createVNode(_component_v_col, {
                                                          cols: "12",
                                                          sm: "6",
                                                          md: "4"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _hoisted_27,
                                                            _createElementVNode("div", _hoisted_28, _toDisplayString(member?.memberInfo?.cusOffNo || '-'), 1)
                                                          ]),
                                                          _: 2
                                                        }, 1024)
                                                      ]),
                                                      _: 2
                                                    }, 1024)
                                                  ]),
                                                  _: 2
                                                }, 1024),
                                                _createVNode(_component_v_card_title, { class: "section-title" }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_icon, { class: "me-2" }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode("mdi-information")
                                                      ]),
                                                      _: 1
                                                    }),
                                                    _createTextVNode(" 상태 정보 ")
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_v_card_text, null, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_row, null, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_col, {
                                                          cols: "12",
                                                          sm: "6",
                                                          md: "4"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _hoisted_29,
                                                            _createElementVNode("div", _hoisted_30, [
                                                              _createVNode(_component_v_chip, {
                                                                color: getStatusColor(member?.memberInfo?.status),
                                                                size: "small"
                                                              }, {
                                                                default: _withCtx(() => [
                                                                  _createTextVNode(_toDisplayString(getStatusText(member?.memberInfo?.status)), 1)
                                                                ]),
                                                                _: 2
                                                              }, 1032, ["color"])
                                                            ])
                                                          ]),
                                                          _: 2
                                                        }, 1024),
                                                        _createVNode(_component_v_col, {
                                                          cols: "12",
                                                          sm: "6",
                                                          md: "4"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _hoisted_31,
                                                            _createElementVNode("div", _hoisted_32, _toDisplayString(member?.memberInfo?.bankResultMsg || '-'), 1)
                                                          ]),
                                                          _: 2
                                                        }, 1024),
                                                        _createVNode(_component_v_col, {
                                                          cols: "12",
                                                          sm: "6",
                                                          md: "4"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _hoisted_33,
                                                            _createElementVNode("div", _hoisted_34, _toDisplayString(member?.memberInfo?.regDt || '-'), 1)
                                                          ]),
                                                          _: 2
                                                        }, 1024),
                                                        _createVNode(_component_v_col, {
                                                          cols: "12",
                                                          sm: "6",
                                                          md: "4"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _hoisted_35,
                                                            _createElementVNode("div", _hoisted_36, _toDisplayString(member?.memberInfo?.bankSendDt || '-'), 1)
                                                          ]),
                                                          _: 2
                                                        }, 1024),
                                                        _createVNode(_component_v_col, {
                                                          cols: "12",
                                                          sm: "6",
                                                          md: "4"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _hoisted_37,
                                                            _createElementVNode("div", _hoisted_38, _toDisplayString(member?.memberInfo?.stopDt || '-'), 1)
                                                          ]),
                                                          _: 2
                                                        }, 1024)
                                                      ]),
                                                      _: 2
                                                    }, 1024)
                                                  ]),
                                                  _: 2
                                                }, 1024)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1024))
                                  }), 128))
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (cmsMembers.value.length > 0)
                        ? (_openBlock(), _createBlock(_component_v_card, {
                            key: 1,
                            variant: "outlined",
                            class: "mt-4"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_card_title, { class: "d-flex align-center" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_icon, { class: "me-2" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("mdi-file-upload")
                                    ]),
                                    _: 1
                                  }),
                                  _createTextVNode(" 출금동의 증빙파일 업로드 ")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_card_text, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_row, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        sm: "4"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_select, {
                                            modelValue: fileForm.value.agreeType,
                                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((fileForm.value.agreeType) = $event)),
                                            label: "증빙파일 구분 *",
                                            variant: "outlined",
                                            density: "compact",
                                            items: [
                        { title: '서면', value: '1' },
                        { title: '전자서명', value: '2' },
                        { title: '녹취', value: '4' }
                      ],
                                            hint: "1: 서면, 2: 전자서명, 4: 녹취"
                                          }, null, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        sm: "4"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_select, {
                                            modelValue: fileForm.value.uploadMethod,
                                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((fileForm.value.uploadMethod) = $event)),
                                            label: "업로드 방식 *",
                                            variant: "outlined",
                                            density: "compact",
                                            items: [
                        { title: 'Multipart (권장)', value: 'multipart' },
                        { title: 'Base64', value: 'base64' }
                      ],
                                            hint: "업로드 방식을 선택하세요"
                                          }, null, 8, ["modelValue", "items"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        sm: "4"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_file_input, {
                                            modelValue: fileForm.value.file,
                                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((fileForm.value.file) = $event)),
                                            label: "증빙파일 선택 *",
                                            variant: "outlined",
                                            density: "compact",
                                            accept: getAcceptedFileTypes(),
                                            "prepend-icon": "mdi-file-document",
                                            "show-size": "",
                                            onChange: onFileChange
                                          }, null, 8, ["modelValue", "accept"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, { cols: "12" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_alert, {
                                            variant: "tonal",
                                            color: "info",
                                            class: "mb-4"
                                          }, {
                                            prepend: _withCtx(() => [
                                              _createVNode(_component_v_icon, { icon: "mdi-information" })
                                            ]),
                                            default: _withCtx(() => [
                                              _hoisted_39,
                                              _hoisted_40
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        class: "text-center"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_btn, {
                                            onClick: uploadAgreeFile,
                                            loading: fileUploadStatus.value,
                                            color: "success",
                                            "prepend-icon": "mdi-upload",
                                            disabled: !fileForm.value.file || !fileForm.value.agreeType || !fileForm.value.uploadMethod
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(" 증빙파일 업로드 (" + _toDisplayString(fileForm.value.uploadMethod === 'base64' ? 'Base64' : 'Multipart') + ") ", 1)
                                            ]),
                                            _: 1
                                          }, 8, ["loading", "disabled"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_v_dialog, {
                        modelValue: deleteDialog.value,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((deleteDialog).value = $event)),
                        "max-width": "400"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_card, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_card_title, { class: "text-h5" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" 회원 해지 확인 ")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_card_text, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(" 정말로 이 회원을 해지하시겠습니까? "),
                                  _hoisted_41,
                                  _createTextVNode(" 회원 ID: " + _toDisplayString(memberId.value), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_card_actions, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_spacer),
                                  _createVNode(_component_v_btn, {
                                    color: "grey-darken-1",
                                    variant: "text",
                                    onClick: _cache[4] || (_cache[4] = ($event: any) => (deleteDialog.value = false))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" 취소 ")
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_btn, {
                                    color: "error",
                                    variant: "text",
                                    onClick: deleteMember,
                                    loading: waitStatus.value
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" 해지 ")
                                    ]),
                                    _: 1
                                  }, 8, ["loading"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createVNode(_component_v_expansion_panels, { class: "mb-4" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_expansion_panel, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_expansion_panel_title, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_icon, { class: "me-2" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("mdi-form-select")
                                    ]),
                                    _: 1
                                  }),
                                  _createTextVNode(" 테스트 데이터 설정 ")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_expansion_panel_text, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_row, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        sm: "6"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_text_field, {
                                            modelValue: form.value.memberName,
                                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.value.memberName) = $event)),
                                            label: "회원명 *",
                                            variant: "outlined",
                                            density: "compact",
                                            hint: "20byte 이내",
                                            maxlength: "20"
                                          }, null, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        sm: "6"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_select, {
                                            modelValue: form.value.serviceCd,
                                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((form.value.serviceCd) = $event)),
                                            label: "서비스코드 *",
                                            variant: "outlined",
                                            density: "compact",
                                            items: [
                          { title: '은행 (BANK)', value: 'BANK' },
                          { title: '카드 (CARD)', value: 'CARD' }
                        ],
                                            hint: "은행: BANK, 카드: CARD"
                                          }, null, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      }),
                                      (form.value.serviceCd === 'BANK')
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            _createVNode(_component_v_col, {
                                              cols: "12",
                                              sm: "6"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_select, {
                                                  modelValue: form.value.bankCd,
                                                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((form.value.bankCd) = $event)),
                                                  label: "은행코드 *",
                                                  variant: "outlined",
                                                  density: "compact",
                                                  items: bankCodes.value,
                                                  "item-title": "bank_name",
                                                  "item-value": "bank_code",
                                                  hint: "은행을 선택하세요"
                                                }, null, 8, ["modelValue", "items"])
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_col, {
                                              cols: "12",
                                              sm: "6"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_text_field, {
                                                  modelValue: form.value.accountNo,
                                                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((form.value.accountNo) = $event)),
                                                  label: "출금계좌번호 *",
                                                  variant: "outlined",
                                                  density: "compact",
                                                  hint: "16byte 이내",
                                                  maxlength: "16"
                                                }, null, 8, ["modelValue"])
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_col, {
                                              cols: "12",
                                              sm: "6"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_text_field, {
                                                  modelValue: form.value.accountName,
                                                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((form.value.accountName) = $event)),
                                                  label: "출금계좌 예금주명 *",
                                                  variant: "outlined",
                                                  density: "compact",
                                                  hint: "20byte 이내",
                                                  maxlength: "20"
                                                }, null, 8, ["modelValue"])
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_col, {
                                              cols: "12",
                                              sm: "6"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_text_field, {
                                                  modelValue: form.value.idNo,
                                                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((form.value.idNo) = $event)),
                                                  label: "생년월일 또는 사업자번호 *",
                                                  variant: "outlined",
                                                  density: "compact",
                                                  hint: "생년월일 앞6자리 또는 사업자번호 10자리",
                                                  maxlength: "10"
                                                }, null, 8, ["modelValue"])
                                              ]),
                                              _: 1
                                            })
                                          ], 64))
                                        : _createCommentVNode("", true),
                                      (form.value.serviceCd === 'CARD')
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                            _createVNode(_component_v_col, {
                                              cols: "12",
                                              sm: "6"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_text_field, {
                                                  modelValue: form.value.cardNo,
                                                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((form.value.cardNo) = $event)),
                                                  label: "카드번호 *",
                                                  variant: "outlined",
                                                  density: "compact",
                                                  hint: "16byte 이내",
                                                  maxlength: "16"
                                                }, null, 8, ["modelValue"])
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_col, {
                                              cols: "12",
                                              sm: "6"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_text_field, {
                                                  modelValue: form.value.valYn,
                                                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((form.value.valYn) = $event)),
                                                  label: "카드 유효기간 *",
                                                  variant: "outlined",
                                                  density: "compact",
                                                  hint: "YYMM 형식 (예: 2312)",
                                                  maxlength: "4",
                                                  placeholder: "YYMM"
                                                }, null, 8, ["modelValue"])
                                              ]),
                                              _: 1
                                            })
                                          ], 64))
                                        : _createCommentVNode("", true),
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        sm: "6"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_text_field, {
                                            modelValue: form.value.hpNo,
                                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((form.value.hpNo) = $event)),
                                            label: "휴대폰번호 *",
                                            variant: "outlined",
                                            density: "compact",
                                            hint: "하이픈 없이 입력 (16byte 이내)",
                                            maxlength: "16"
                                          }, null, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        sm: "6"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_text_field, {
                                            modelValue: form.value.email,
                                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((form.value.email) = $event)),
                                            label: "이메일",
                                            variant: "outlined",
                                            density: "compact",
                                            type: "email",
                                            hint: "30byte 이내",
                                            maxlength: "30"
                                          }, null, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        sm: "6"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_text_field, {
                                            modelValue: form.value.serviceName,
                                            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((form.value.serviceName) = $event)),
                                            label: "상품명/서비스명",
                                            variant: "outlined",
                                            density: "compact",
                                            hint: "30byte 이내",
                                            maxlength: "30"
                                          }, null, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        sm: "6"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_select, {
                                            modelValue: form.value.cusType,
                                            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((form.value.cusType) = $event)),
                                            label: "현금영수증 발행타입",
                                            variant: "outlined",
                                            density: "compact",
                                            items: [
                          { title: '소득공제 (1)', value: '1' },
                          { title: '지출증빙 (2)', value: '2' }
                        ]
                                          }, null, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        sm: "6"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_text_field, {
                                            modelValue: form.value.cusOffNo,
                                            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((form.value.cusOffNo) = $event)),
                                            label: "현금영수증 인증번호",
                                            variant: "outlined",
                                            density: "compact",
                                            hint: "휴대폰번호 또는 현금영수증카드번호/사업자번호",
                                            maxlength: "20"
                                          }, null, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        sm: "6"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_text_field, {
                                            modelValue: form.value.userDefine,
                                            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((form.value.userDefine) = $event)),
                                            label: "사용자정의 필드",
                                            variant: "outlined",
                                            density: "compact",
                                            hint: "20byte 이내",
                                            maxlength: "20"
                                          }, null, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", _hoisted_42, [
                        _createVNode(_component_v_btn, {
                          onClick: sendRequest,
                          loading: waitStatus.value,
                          color: "primary",
                          size: "large",
                          "prepend-icon": "mdi-send",
                          disabled: !memberId.value
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(waitStatus.value ? '요청 중...' : 'CMS API 요청 보내기'), 1)
                          ]),
                          _: 1
                        }, 8, ["loading", "disabled"])
                      ]),
                      (result.value)
                        ? (_openBlock(), _createBlock(_component_v_card, {
                            key: 2,
                            variant: "outlined",
                            class: "mt-4"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_card_title, { class: "d-flex align-center" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_icon, {
                                    color: isSuccess.value ? 'success' : 'error',
                                    class: "me-2"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(isSuccess.value ? 'mdi-check-circle' : 'mdi-alert-circle'), 1)
                                    ]),
                                    _: 1
                                  }, 8, ["color"]),
                                  _createTextVNode(" 응답 결과 "),
                                  _createVNode(_component_v_spacer),
                                  _createVNode(_component_v_chip, {
                                    color: isSuccess.value ? 'success' : 'error',
                                    size: "small"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(isSuccess.value ? '성공' : '실패'), 1)
                                    ]),
                                    _: 1
                                  }, 8, ["color"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_card_text, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_row, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_col, { cols: "12" }, {
                                        default: _withCtx(() => [
                                          (result.value?.data?.memberInfo)
                                            ? (_openBlock(), _createBlock(_component_v_alert, {
                                                key: 0,
                                                color: isSuccess.value ? 'success' : 'error',
                                                variant: "tonal",
                                                class: "mb-4"
                                              }, {
                                                prepend: _withCtx(() => [
                                                  _createVNode(_component_v_icon, {
                                                    icon: isSuccess.value ? 'mdi-check-circle' : 'mdi-alert-circle'
                                                  }, null, 8, ["icon"])
                                                ]),
                                                default: _withCtx(() => [
                                                  _hoisted_43,
                                                  _createElementVNode("div", _hoisted_44, [
                                                    _createElementVNode("div", null, [
                                                      _hoisted_45,
                                                      _createTextVNode(" " + _toDisplayString(getStatusText(result.value.data.memberInfo.status)), 1)
                                                    ]),
                                                    _createElementVNode("div", null, [
                                                      _hoisted_46,
                                                      _createTextVNode(" " + _toDisplayString(result.value.data.memberInfo.bankResultMsg || '-'), 1)
                                                    ]),
                                                    _createElementVNode("div", null, [
                                                      _hoisted_47,
                                                      _createTextVNode(" " + _toDisplayString(result.value.data.memberInfo.regDt || '-'), 1)
                                                    ]),
                                                    _createElementVNode("div", null, [
                                                      _hoisted_48,
                                                      _createTextVNode(" " + _toDisplayString(result.value.data.memberInfo.bankSendDt || '-'), 1)
                                                    ]),
                                                    _createElementVNode("div", null, [
                                                      _hoisted_49,
                                                      _createTextVNode(" " + _toDisplayString(result.value.data.memberInfo.stopDt || '-'), 1)
                                                    ])
                                                  ])
                                                ]),
                                                _: 1
                                              }, 8, ["color"]))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, { cols: "12" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_code, { class: "d-block" }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(JSON.stringify(result.value, null, 2)), 1)
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_snackbar, {
        modelValue: snackbar.show,
        "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((snackbar.show) = $event)),
        color: snackbar.color,
        timeout: 3000,
        location: "top"
      }, {
        actions: _withCtx(() => [
          _createVNode(_component_v_btn, {
            variant: "text",
            onClick: _cache[20] || (_cache[20] = ($event: any) => (snackbar.show = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 닫기 ")
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(snackbar.text) + " ", 1)
        ]),
        _: 1
      }, 8, ["modelValue", "color"])
    ]),
    _: 1
  }))
}
}

})